import NotificationsPage from './list/NotificationsPage.vue';

const routes = [
  {
    path: '/notifications',
    name: 'notifications',
    component: NotificationsPage,
    meta: {
      title: 'Notifications',
      requiresAuth: true
    }
  }
];

export default routes;
